export default "__VITE_ASSET__a43bedad__"